if (!customElements.get('information-banner')) {
  class InformationBanner extends HTMLElement {
    constructor() {
      super();

      this.bannerItems = this.querySelectorAll('.information-banner__item');
      document.documentElement.style.setProperty('--window-height', `${window.innerHeight}px`);
      document.documentElement.style.setProperty('--section-height', `${window.innerHeight}px`);

      window.addEventListener('resize', () => {
        if (window.innerWidth >= 768) {
          document.documentElement.style.setProperty('--window-height', `${window.innerHeight}px`);
        }
      });

      if (this.classList.contains('js-information-banner-init')) {
        window.addEventListener('scroll', () => this.updateSections(this.bannerItems));
        window.addEventListener('resize', () => this.updateSections(this.bannerItems));

        this.updateSections(this.bannerItems);
      }
    }

    updateSections(items) {
      let stickyTop = 210;

      if (window.innerWidth < 1280 && window.innerWidth > 768) {
        stickyTop = 180;
      } else if (window.innerWidth <= 768) {
        stickyTop = 160;
      }

      items.forEach((item, index) => {
        if (index > 1) {
          const rect = item.getBoundingClientRect();
          const itemScrollPercent = (window.innerHeight - rect.top) / (window.innerHeight - stickyTop) * 100;
          const itemTopPercent = itemScrollPercent / 100 * stickyTop;

          if (
            itemScrollPercent >= 0 && itemScrollPercent <= 100
            && item.previousSibling.getBoundingClientRect().top >= 0
          ) {
            item.previousSibling.style.top = `${Math.ceil(stickyTop - itemTopPercent)}px`;
          }
        }
      });
    }
  }

  customElements.define('information-banner', InformationBanner);
}
